var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "admin-table" },
    [
      _c(
        "ma-modal",
        { ref: "adminGagEditModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("gagUserLimits.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "user",
                      col: 2,
                      icon: "house",
                      literal: "gagUserLimits.table.user",
                      disabled: ""
                    },
                    model: {
                      value: _vm.userLimits.user,
                      callback: function($$v) {
                        _vm.$set(_vm.userLimits, "user", $$v)
                      },
                      expression: "userLimits.user"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "hour_price_max_limit",
                      col: 2,
                      icon: "house",
                      literal: "gagUserLimits.table.hour_price_max_limit"
                    },
                    model: {
                      value: _vm.userLimits.hour_price_max_limit,
                      callback: function($$v) {
                        _vm.$set(_vm.userLimits, "hour_price_max_limit", $$v)
                      },
                      expression: "userLimits.hour_price_max_limit"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "hour_price_min_limit",
                      col: 2,
                      icon: "house",
                      literal: "gagUserLimits.table.hour_price_min_limit"
                    },
                    model: {
                      value: _vm.userLimits.hour_price_min_limit,
                      callback: function($$v) {
                        _vm.$set(_vm.userLimits, "hour_price_min_limit", $$v)
                      },
                      expression: "userLimits.hour_price_min_limit"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("p", { staticClass: "mg mg--b-4 mg--t-4 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("gagUserLimits.title")))
      ]),
      _vm.stateUserIsSuperAdmin
        ? _c("ma-input-select", {
            attrs: {
              type: "select",
              name: "companyFilter",
              col: 1,
              icon: "house",
              literal: "users.table.company",
              options: _vm.companies,
              value: _vm.companyFilter,
              nullValue: ""
            },
            on: { change: _vm.filterByCompanyId }
          })
        : _vm._e(),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "bg-blueDark" },
            [
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagUserLimits.table.user")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(
                    _vm._s(_vm.$t("gagUserLimits.table.hour_price_max_limit"))
                  )
                ])
              ]),
              _c("th", { staticClass: "no--border" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(
                    _vm._s(_vm.$t("gagUserLimits.table.hour_price_min_limit"))
                  )
                ])
              ]),
              _vm.stateUserIsSuperAdmin
                ? [
                    _c("th", {
                      staticClass: "border-right",
                      attrs: { width: "50px" }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm.hasData
          ? _c(
              "tbody",
              _vm._l(_vm.table, function(row) {
                return _vm.table
                  ? _c(
                      "tr",
                      [
                        _c("td", [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.user))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.hour_price_max_limit))
                          ])
                        ]),
                        _c("td", { staticClass: "no--border" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.hour_price_min_limit))
                          ])
                        ]),
                        _vm.stateUserIsSuperAdmin
                          ? [
                              _c("td", { staticClass: "text-align--right" }, [
                                _c(
                                  "div",
                                  { staticClass: "grid grid--jc-bottom" },
                                  [
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action",
                                      attrs: {
                                        name: "edit",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleEdit(row)
                                        }
                                      }
                                    }),
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action mg mg--l-2",
                                      attrs: {
                                        name: "trash",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(row)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              }),
              0
            )
          : _vm._e()
      ]),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "grid grid--jc-bottom mg mg--t-4" },
            [
              _c("ma-paginator", {
                staticClass: "mg mg--t-2 mg--b-4",
                attrs: { current: _vm.currentPage, total: _vm.totalPages },
                on: {
                  "page:update": _vm.handlePageUpdate,
                  "page:set": _vm.handlePageSet
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.hasData
        ? _c("ma-empty", {
            attrs: {
              icon: "recherche",
              title: _vm.$t("common.noresults.short"),
              descr: _vm.$t("common.noresults.long")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }